import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=6f23f832&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f23f832",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f23f832')) {
      api.createRecord('6f23f832', component.options)
    } else {
      api.reload('6f23f832', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=6f23f832&scoped=true&", function () {
      api.rerender('6f23f832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FmzVCxiUafDv/JS/comp/SearchFilterTokens.vue"
export default component.exports